<div class="st-page">
  <div class="st-page-head">
    <div class="fsr-head-left">
      <button type="button" class="sfr-icon-btn" (click)="goBack()"><i class="ri-arrow-left-line"></i></button>
      <h1 class="st-title">{{ 'viewStaffAttendance' | translate }}</h1>
    </div>
    <button type="button" class="sfr-icon-btn" (click)="toggleSearch()">
      <i class="ri-search-line"></i>
    </button>
  </div>

  <div class="va-date-row">
    <p-calendar [ngModel]="selectedDateObj" (onSelect)="onDateChange($event)"
      [showIcon]="true" dateFormat="dd M yy" appendTo="body"
      inputStyleClass="va-date-input"></p-calendar>
  </div>

  <div class="sb-search-box" *ngIf="searchOpen">
    <i class="ri-search-line"></i>
    <input type="text" [ngModel]="searchString" (ngModelChange)="onSearchInput($event)"
      placeholder="{{ 'searchStaffPlaceholder' | translate }}" autofocus />
  </div>

  <div class="st-tv-list" *ngIf="fetchingData" (scroll)="onListScroll()">
    <div class="st-card va-skeleton-row" *ngFor="let s of skeletonRows"></div>
  </div>

  <ng-container *ngIf="!fetchingData">
    <div class="st-tv-list" (scroll)="onListScroll()">
      <div class="st-card va-staff-card" *ngFor="let s of staffData">
        <div class="va-staff-head">
          <div class="st-avatar">{{ s.name.charAt(0) }}</div>
          <span class="va-status-dot" [class.va-status-in]="s.inTime" [class.va-status-out]="!s.inTime"></span>
          <div class="st-list-text">
            <div class="st-list-title">{{ s.name }}</div>
            <div class="st-list-sub">{{ 'employeeId' | translate }}: {{ s.employmentId }}</div>
          </div>
        </div>
        <div class="va-time-row">
          <div class="va-time-col">
            <span class="va-time-label">{{ 'checkInTime' | translate }}</span>
            <span class="va-time-value">{{ formatTime(s.inTime) }}</span>
          </div>
          <div class="va-time-col">
            <span class="va-time-label">{{ 'checkOutTime' | translate }}</span>
            <span class="va-time-value">{{ formatTime(s.outTime) }}</span>
          </div>
          <div class="va-time-col">
            <span class="va-time-label">{{ 'duration' | translate }}</span>
            <span class="va-time-value">{{ duration(s) }}</span>
          </div>
        </div>
      </div>
    </div>

    <p class="sf-empty" *ngIf="!staffData.length">{{ 'noAttendanceDataAvailable' | translate }}</p>

    <div class="sf-load-more" *ngIf="pageNumber < maxPageNumber">
      <button class="st-btn st-btn-secondary" (click)="loadMore()" [disabled]="fetchingPaginationData">
        {{ (fetchingPaginationData ? 'pleaseWait' : 'loadMore') | translate }}
      </button>
    </div>
  </ng-container>
</div>
